import React, { Component } from 'react';
import YouTube from 'react-youtube';

export default class YouTubePlayer extends Component {
  constructor() {
    super();

    const self = this;

    this._currentTime = 0;
    this._muted = false;
    this.loaded = false;
    this.ended = false;
    this.paused = false;

    Object.defineProperty(this, 'currentTime', {
      get: () => self._currentTime,
      set: (newValue) => self.seek(newValue),
    });

    Object.defineProperty(this, 'muted', {
      get: () => self._muted,
      set: (newValue) => self.mute(newValue),
    });

    Object.defineProperty(this, 'offsetHeight', {
      get: () => 304,
    });

    Object.defineProperty(this, 'offsetWidth', {
      get: () =>
        this.props.videoHeight && this.props.videoWidth
          ? (this.props.videoWidth / this.props.videoHeight) * 304
          : 538,
    });

    Object.defineProperty(this, 'offsetLeft', {
      get: () => (538 - this.offsetWidth) / 2,
    });

    Object.defineProperty(this, 'videoHeight', {
      get: () => 720,
    });

    Object.defineProperty(this, 'videoWidth', {
      get: () => 1280,
    });
  }

  componentDidMount() {
    var self = this;
    this.fetchInterval = setInterval(() => {
      if (!self.player) return;
      self._currentTime = self.player.getCurrentTime();
      self.props.onTimeUpdate();

      //in case it doesn't load automatically
      const duration = self.player.getDuration();
      if (duration) {
        self.gotDuration(duration);
      }
    }, 500);
  }

  componentWillUnmount() {
    clearTimeout(this.fetchInterval);
  }

  play() {
    if (!this.player) return;
    this.player.playVideo();
  }
  pause() {
    if (!this.player) return;
    this.player.pauseVideo();
  }
  seek(time) {
    if (!this.player) return;
    this.player.seekTo(time);
  }
  mute(muted) {
    if (!this.player) return;
    if (muted) {
      this.player.mute();
    } else {
      this.player.unMute();
    }
    this._muted = muted;
  }

  gotDuration(duration) {
    this.duration = duration;
    if (!this.loaded) {
      this.props.onLoadedData();
      this.loaded = true;
    }
  }

  render() {
    var self = this;
    return (
      <YouTube
        videoId={this.props.videoId}
        containerClassName="youtube-container"
        onReady={(e) => {
          self.player = e.target;
          self.gotDuration(self.player.getDuration());
        }}
        onPlay={() => {
          self.ended = false;
          self.gotDuration(self.player.getDuration());
        }}
        onEnd={() => {
          self.ended = true;
          self.props.onEnded();
        }}
        opts={{
          height: 304,
          width: '100%',
          playerVars: {
            autoplay: 1,
            controls: 0,
            disablekb: 1,
            fs: 0,
            loop: 1,
            modestbranding: 1,
            playsinline: 1,
          },
        }}
      />
    );
  }
}
